import { useState } from "react";
//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
//CONTEXT;
import { useCreativeState, useCreativeDispatch } from "../../../../contexts/creative.context";
//ASSETS
import studio_config from "../../../../configs/studio.json";
//TYPES
export interface StudioConfig {
  [key: string]: any;
}

export default function Reactions() {
  const [emojiPickerVisibleArray, setEmojiPickerVisibleArray] = useState([false, false, false, false, false]);
  const [emojiId, setEmojiId] = useState(0);
  const creative = useCreativeState();
  const creativeDispatch = useCreativeDispatch();
  const studioConfig: StudioConfig = studio_config;

  return (
    <>
      {creative.metadata.features.reactions.visible ? (
        <>
          <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={2} />
          <div className="flex flex-column w-70">
            <div style={{ display: "flex" }}>
              <ComponentLibrary.PCEmojiReactionBar
                totalEmojis={studioConfig.formats[creative.metadata.format]?.inputs.features.reactions.maxEmojis[creative.metadata.aspectRatio]}
                emojiArray={creative.metadata.features.reactions.emojis}
                handleClickButton={(e) => {
                  e.stopPropagation();
                  setEmojiId(parseInt(e.target.id));
                  // update emoji to empty string when clicked
                  const updatedEmojiArray = creative.metadata.features.reactions.emojis.map((x: string, index: number) => {
                    if (parseInt(e.target.id) === index) return null;
                    else return x;
                  });
                  creativeDispatch({
                    type: "UPDATE_CREATIVE_METADATA_FEATURES_REACTIONS_EMOJIS",
                    payload: { emojis: updatedEmojiArray },
                  });
                  // set corrosponding emojiPicker in emojiPickerVisibleArray to true once clicked
                  const updatedPickerArray = emojiPickerVisibleArray.map((_: boolean, index: number) => {
                    if (parseInt(e.target.id) === index) return true;
                    else return false;
                  });
                  setEmojiPickerVisibleArray(updatedPickerArray);
                }}
                handleClickModal={(e) => {
                  // update correct item in emojiArray with emoji unicode
                  const updatedEmojiArray = creative.metadata.features.reactions.emojis.map((x: string, index: number) => {
                    if (emojiId === index) return e.native;
                    else return x;
                  });
                  creativeDispatch({
                    type: "UPDATE_CREATIVE_METADATA_FEATURES_REACTIONS_EMOJIS",
                    payload: { emojis: updatedEmojiArray },
                  });
                  // close open emoji picker when user has selected emoji
                  const updatedPickerArray = emojiPickerVisibleArray.map((x: boolean, index: number) => {
                    if (emojiId === index) return !x;
                    else return x;
                  });
                  setEmojiPickerVisibleArray(updatedPickerArray);
                }}
                emojiPickerVisibleArray={emojiPickerVisibleArray}
                setEmojiPickerVisibleArray={setEmojiPickerVisibleArray}
              />
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
